export default Object.freeze({
  ERROR_TYPE: ['EXCEED_MAX', 'SUBCEED_MIN', 'MISMATCH_ORDER'],
  DEFAULT_MAX_MINUTE: 60 * 24,
  DEFAULT_MIN_MINUTE: 1,
});
